module.exports = __webpack_public_path__ + "static/SY-interviews-8f05a9e054c19db47c15f47017b0251f.png";